<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'QoList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Quality Of Service (QoS)
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Quality Of Service (QoS)</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Qo">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools"></div>
            </div>
            <div class="card-body pb-2">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>

                  <!-- <div class="form-group required d-none">
                    <label class="control-label">Enable</label>
                    <select
                      class="form-control"
                      style="width: 100%"
                      name="type"
                      v-model="value.isactive"
                      id="isactive"
                      v-validate="'required'"
                    >
                      <option value="1">Enable</option>
                      <option value="0">Disable</option>
                    </select>
                    <div
                      class="help text-danger"
                      v-show="errors.has('isactive')"
                    >
                      {{ errors.first('isactive') }}
                    </div>
                  </div> -->

                  <div class="form-group">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">Enable</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="isactive"
                          v-model="value.isactive"
                          id="isactive"
                          value="1"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>
                  <div v-if="value.isactive == '1'">
                    <div class="form-group">
                      <label class="control-label">Download(Mbps)</label>
                      <input
                        type="text"
                        id="download"
                        name="download"
                        v-bind:class="{ 'has-error': errors.has('download') }"
                        v-validate="{
                          regex: /^-?\d+$/,
                        }"
                        v-model="value.download"
                        class="form-control download"
                        placeholder="Download"
                      />
                      <div class="help text-danger" v-show="errors.has('download')">
                        {{ errors.first("download") }}
                      </div>
                    </div>
                    <div class="form-group required">
                      <label class="control-label">Upload(Mbps)</label>
                      <input
                        type="text"
                        id="upload"
                        name="upload"
                        v-bind:class="{ 'has-error': errors.has('upload') }"
                        v-validate="{
                          required: true,
                          regex: /^-?\d+$/,
                        }"
                        v-model="value.upload"
                        class="form-control upload"
                        placeholder="Upload"
                      />
                      <div class="help text-danger" v-show="errors.has('upload')">
                        {{ errors.first("upload") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "QoForm",
  metaInfo: {
    title: "Qos | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),

    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      upload: 0,
      download: 0,
      isactive: 1,
    },
    pre: {},
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/qos";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/qos/" + _this.$route.params.id;
            method = "PUT";
          }
          (_this.value.download = _this.value.download * 1024),
            (_this.value.upload = _this.value.upload * 1024),
            axios({
              method: method,
              url: api_url,
              data: _this.value,
              headers: { "Content-Type": "application/json" },
            })
              .then(function (response) {
                _this.$toaster.success(response.data.message);
                _this.$router.push({ name: "QoList" });
              })
              .catch((errors) => {
                if (errors.response.status === 500) {
                  _this.$toaster.error(errors.response.data.message);
                }
                _this.$setErrorsFromResponse(errors.response.data);
              })
              .finally(() => {
                _this.is_loading = false;
              });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/qos/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            this.value.download = (this.value.download / 1024).toFixed(0);
            this.value.upload = (this.value.upload / 1024).toFixed(0);
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          })
          .catch((error) => {
            console.log(error.response);
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
			this.$emit("update:layout", MasterLayout);
		}, */
};
</script>
